import { memo } from 'react'
import Avatar from '@mui/material/Avatar'
import { useTheme } from '@mui/material'

import { AnimateBorder } from 'src/components/shared/animate'
import Text from '../../components/shared/text/Text'
import { THEME_MODE } from '../../constants/theme'

const UserAvatar = ({
  label,
  size = 40,
  borderSize = 60,
  fontSize = 16,
  sx,
  noAnimation = false
}) => {
  const theme = useTheme()
  const avatarBgColor =
    theme.palette.mode === THEME_MODE.LIGHT ? 'grey.200' : 'grey.700'
  return (
    <AnimateBorder
      sx={{ width: size, height: size, borderRadius: '50%', ...sx }}
      slotProps={
        !noAnimation && {
          primaryBorder: { size: borderSize, sx: { color: 'primary.main' } }
        }
      }
    >
      <Avatar sx={{ width: 1, height: 1, bgcolor: avatarBgColor }}>
        {label && (
          <Text
            label={label}
            color='primary.main'
            fontSize={fontSize}
            fontWeight={600}
            sx={{ textTransform: 'uppercase' }}
          />
        )}
      </Avatar>
    </AnimateBorder>
  )
}

export default memo(UserAvatar)
